/**
 * Email API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { sendEmail } from "../generated/email/email";

import { wrapMethod } from "./utils";

export const email = {
  /** @see sendEmail */
  sendEmail: wrapMethod(sendEmail),
} as const;

export type EmailApi = typeof email;
